import React from "react";
import { Link } from "react-router-dom";

import "./WhatWeDo.css"; // optional
import FeatureCards from "../../components/feature-cards/FeatureCards";

const SERVICES = [
  {
    icon: "🌐",
    title: "Web Development",
    desc: "Modern responsive web apps using React & Next.js",
  },
  {
    icon: "📱",
    title: "Mobile App Development",
    desc: "Android & iOS apps with Flutter / React Native",
  },
  {
    icon: "🤖",
    title: "AI & Machine Learning",
    desc: "Smart AI solutions for automation & insights",
  },
  {
    icon: "☁️",
    title: "Cloud & DevOps",
    desc: "Scalable cloud infrastructure & CI/CD pipelines",
  },
  {
    icon: "🔐",
    title: "Cyber Security",
    desc: "Secure applications and vulnerability protection",
  },
  {
    icon: "🎨",
    title: "UI/UX Design",
    desc: "Clean, modern, and user-friendly designs",
  },
];

const WhatWeDo: React.FC = () => {
  return (
    <div>

      {/* SERVICES SECTION */}
      <section className="home-services">
        <div className="container">
          <div className="home-services__header">
            <span className="section-label">What We Do</span>
            <h2 className="section-title">Our Technology Services</h2>
            <p className="section-subtitle">
              Ajera Infotech builds innovative software and AI solutions to solve real-world problems.
            </p>
          </div>

          <div className="home-services__grid">
            {SERVICES.map((s, i) => (
              <div key={i} className="svc-card">
                <div className="svc-card__icon">{s.icon}</div>
                <h3 className="svc-card__title">{s.title}</h3>
                <p className="svc-card__desc">{s.desc}</p>
                <div className="svc-card__bar" />
              </div>
            ))}
          </div>

          <div className="home-services__cta">
            <Link to="/contact" className="btn-outline">
              Contact Us →
            </Link>
          </div>
        </div>
      </section>

      {/* FEATURE CARDS */}
      <FeatureCards />

    </div>
  );
};

export default WhatWeDo;